import {Config} from '@spartacus/core';

export const skipToContentConfig: SkipToContentConfigModel = {
  accessibility: {
    skipToContent: {
      paths: ['configureCPQCONFIGURATOR', 'cart', 'checkoutReviewOrder', 'checkoutDataEntry'],
    },
  },
};

export interface SkipToContentConfigModel extends Config {
  accessibility: {
    skipToContent: {
      paths: string[];
    };
  };
}
